import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry as LogEntryComponent } from './logEntry';

type ConversationTranscriptionStartedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_TRANSCRIPTION_STARTED'>;
};

export const ConversationTranscriptionStarted = ({
  entry,
}: ConversationTranscriptionStartedProps): JSX.Element => {
  const text = <>Conversation transcription started</>;
  return <LogEntryComponent entry={entry} text={text} />;
};
